import React, { Component } from 'react';
import Terminal from './Terminal';

class TerminalWindow extends Component {
  constructor() {
    super();
    this.onInput = this.onInput.bind(this);
    this.focusText = this.focusText.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.setTyping = this.setTyping.bind(this);
    this.scroll = this.scroll.bind(this);
    this.execute = this.execute.bind(this);

    this.state = {
      terminal: new Terminal(this),
      canType: false,
      histIndex: 0,
      queryBuffer: '',
      margins: {
        right: false,
        bottom: false,
      },
    };
  }

  focus(el) {
    el.focus();
    if (typeof window.getSelection !== "undefined"
      && typeof document.createRange !== "undefined") {
      var range = document.createRange();
      range.selectNodeContents(el);
      range.collapse(false);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    } else if (typeof document.body.createTextRange !== "undefined") {
      var textRange = document.body.createTextRange();
      textRange.moveToElementText(el);
      textRange.collapse(false);
      textRange.select();
    }
  }

  focusText() {
    if(this.refs.text) {
      this.focus(this.refs.text);
    }
  }

  scroll() {
    this.refs.content.scrollTop = this.refs.content.scrollHeight;
  }

  setTyping(enable) {
    this.setState({
      canType: enable,
    });
  }

  updateGlobal() {
    let app = this;
    window.terminal = {
      terminal: this.state.terminal,
      scroll: this.scroll,
      execute: query => {
        this.state.terminal.execute(query, app);
        this.setState(this.state.terminal);
      }
    };
  }

  updateTerminal() {
    this.setState({
      terminal: this.state.terminal
    });
    this.props.updateTerminal();
    this.focusText();
  }

  componentDidMount() {
    this.refs.text.innerText = ' ';
    this.focusText();
    this.updateGlobal();

    this.setState({
      canType: true,
    });

    this.state.terminal.startup(this);
  }

  onInput(e) {
    let text = this.refs.text.innerText;
    if(text === '') {
      this.refs.text.innerText = ' ';
    }
  }

  onKeyPress(e) {
    let state = this.state;
    let histIndex = state.histIndex;
    let terminal = this.state.terminal;
    let hist = terminal.hist;

    switch(e.keyCode) {
      case 13: {
        e.preventDefault();

        let query = this.refs.text.innerText;
        this.refs.text.innerText = ' ';

        this.state.terminal.execute(query, this);
        this.setState(this.state.terminal);
      } break;

      case 38: { // up
        let newIndex = histIndex + 1;

        if(histIndex <= 0) {
          this.setState({
            queryBuffer: this.refs.text.innerText,
          });
        }

        if(newIndex > hist.length) {
          newIndex = hist.length;
        }

        this.refs.text.innerText = hist[hist.length - newIndex];

        this.setState({
          histIndex: newIndex,
        });
      } break;

      case 40: { // down
        let newIndex = histIndex - 1;

        if(newIndex < 0) {
          newIndex = 0
        }

        if(newIndex <= 0) {
          if(histIndex > 0) {
            this.refs.text.innerText = this.state.queryBuffer;
          }
        } else {
          this.refs.text.innerText = hist[hist.length - newIndex]
        }

        this.setState({
          histIndex: newIndex,
        });


      } break;

      default:
        this.setState({
          histIndex: 0,
        });
        break;
    }
  }

  componentDidUpdate() {
    this.scroll();
    this.updateGlobal();
  }

  execute(cmd) {
    let commands = {
      'dir': args => {
        if(this.props.toggleDir) {
          this.props.toggleDir();
        }
        return <div></div>;
      },
    };

    if(commands[cmd[0]]) {
      return commands[cmd[0]](cmd);
    } else {
      return (<div>{cmd[0]}: command not found</div>);
    }
  }

  render() {
    let state = this.state;
    let terminal = state.terminal;

    let outputs = [];
    for(let i in terminal.outputs) {
      let output = terminal.outputs[i];

      let history = null;
      if(output.doPrintHistory) {
        history = (
          <span>
            <span className="directory">
              <span className="user">{output.user}</span>
              <span>@</span>
              <span className="computer">{output.host}:</span>
              <span className="folder">{terminal.getDirectory(output.directory)}</span>
              <span>$ </span>
            </span>
            <span className="text">{output.query}</span>
          </span>
        );
      }

      outputs.push(
        <div className="output" key={i}>
          { history }
          <span className="print">{output.print}</span>
        </div>
      );
    }

    return (
      <div className={`terminal`} onClick={this.focusText}>

        <div className="title-bar">
          <div className="button-area">
            <div>
              <span className="icon">X</span>
            </div>
            <div>
              <span className="icon">-</span>
            </div>
            <div>
              <span className="icon">Y</span>
            </div>
          </div>

          <div className="title-area">
            <div className="title-icon"></div>
            <div className="title-text">/{terminal.currentDirectory[terminal.currentDirectory.length - 1]}</div>
          </div>
        </div>

        <div className="content" ref="content">
          <div className="content-wrapper">
            { outputs }

            <div className={`input ${!this.state.canType ? 'hidden' : ''}`}>
              <span className="directory">
                <span className="user">{terminal.currentUser}</span>
                <span>@</span>
                <span className="computer">{terminal.currentHost}:</span>
                <span className="folder">{terminal.getDirectory()}</span>
                <span>$ </span>
              </span>
              <span ref="text" onInput={this.onInput} onKeyDown={this.onKeyPress} className="text" contentEditable="true"></span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TerminalWindow;



// WEBPACK FOOTER //
// ./src/TerminalWindow.js